// extracted by mini-css-extract-plugin
export default {"time":"styles_time__T4OTn","stats":"styles_stats__NBPcx","markValue":"styles_markValue__tmxGZ"};